export default __webpack_public_path__ + "static/media/share-svg-black.e2c6f876.svg";